import { createSlice } from '@reduxjs/toolkit';

const promptMasterSlice = createSlice({
    name: 'promptMaster',
    initialState: { stateCounter: 0 },
    reducers: {
      changePromptMasterState(state) {
        state.stateCounter++;
      },
    },
  });
  
  export const { changePromptMasterState } = promptMasterSlice.actions;
  export default promptMasterSlice.reducer;
